/** Ajuda — Gestão: clientes, funcionários, fornecedores, bairros, horários. */
export const gestao = {
  id: "gestao",
  titulo: "Clientes, equipe e entrega",
  icone: "Users",
  intro: "Cadastros que fazem a operação girar: clientes, funcionários e permissões, fornecedores, bairros e horários.",
  topicos: [
    {
      pergunta: "O que tem na tela de Clientes?",
      resposta: "Pessoas → Clientes lista todo mundo que já pediu (o cadastro nasce sozinho no primeiro pedido do cardápio, do bot ou do PDV): contato, endereços, histórico de pedidos, ticket médio e frequência. Dá pra editar dados, ver o total gasto e identificar clientes sumidos pra reativar com cupom.",
      videos: ["2XU_eKdhsZM"],
    },
    {
      pergunta: "Como cadastro funcionários e controlo o que cada um acessa?",
      resposta: "Pessoas → Funcionários: crie o funcionário com telefone e senha, e escolha um cargo (Gerente, Atendente, Cozinheiro, Entregador) ou personalize módulo a módulo. O funcionário loga com o próprio telefone e só vê as abas liberadas — um cozinheiro, por exemplo, pode ver só o KDS e os pedidos. O módulo marcado libera tudo o que a tela dele oferece: quem tem Financeiro vê, lança, edita e apaga despesas. Para alguém que cuida de tudo (gerente, contador), use o botão Marcar tudo: ele passa a fazer o trabalho de um administrador. Usuários, backup, troca de plano e a conexão com o iFood e com a Meta continuam com o dono.",
      videos: ["rXusPO75dCc"],
    },
    {
      pergunta: "Pra que serve o cadastro de Fornecedores?",
      resposta: "Pessoas → Fornecedores guarda os dados de quem te vende insumo. Ele se conecta às Compras: cada nota lançada referencia o fornecedor, e a tela mostra o total comprado e a variação de preços por fornecedor — útil pra negociar.",
      videos: ["Ewi3IFYXtVs"],
    },
    {
      pergunta: "Como configuro bairros e taxa de entrega?",
      resposta: "Localização → Bairros: cadastre cada bairro atendido com a taxa e o tempo estimado. No cardápio online e no PDV, a taxa entra sozinha quando o cliente escolhe o bairro. Área de Entrega (desenho no mapa com taxa por distância) está em finalização — aparece como Em breve.",
      videos: ["lll1RjRmzLE"],
    },
    {
      pergunta: "Como funcionam os Horários?",
      resposta: "Configurações → Horários define o funcionamento por dia da semana, com mais de um intervalo por dia se precisar (ex.: almoço e jantar). Fora do horário, o cardápio bloqueia o checkout e a Cleo informa quando reabre. O fechamento manual (imprevisto) tem prioridade sobre a tabela.",
      videos: ["BzLx77utLoc"],
    },
    {
      pergunta: "O que encontro em Configurações → Sistema?",
      resposta: "Seis áreas: IMPRESSÃO (conector e modelos de cupom), APARÊNCIA (tema claro/escuro e cor do painel), INTEGRAÇÃO (importar cardápio de outros sistemas), EMPRESA (nome, logo, contato — o que aparece no cardápio e no cupom), OPÇÕES (comportamentos do dia a dia) e CONTROLE (regras de segurança da operação).",
      videos: ["Ew3E3kD7xic", "b9iie0gSTMo", "s07XAMxZI8Y", "yiDx_AtEMOk"],
    },
    {
      pergunta: "Como funciona a Assinatura?",
      resposta: "Configurações → Assinatura mostra seu plano atual, o vencimento e o histórico de pagamentos da mensalidade. É por lá que se faz upgrade de plano — a liberação das abas novas é imediata.",
    },
  ],
};
